export default __webpack_public_path__ + "static/media/flag-british-indian-ocean-territory.19a7cc88.svg";